export const isHttpLink = (value: string): boolean => {
  const regex = /^http[s]?:\/\//;
  return regex.test(value);
};
